


























import { defineComponent, onBeforeUnmount, onMounted } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { LoginSignUpModalData } from "@/types";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "GuestNavigationBar",
  components: { BaseButton },
  setup() {
    const handleLoginClick = (data?: LoginSignUpModalData) => {
      emitter.emit(EVENTS.SHOW_LOGIN_SIGNUP_MODAL, { showLogin: data?.showLogin });
    };

    const setSafeBottomPosition = () => {
      const root = document.documentElement;
      root.style.setProperty("--safe-bottom-position-guest", "106px");
    };

    setSafeBottomPosition();

    onMounted(() => {
      setSafeBottomPosition();
    });

    onBeforeUnmount(() => {
      const root = document.documentElement;
      root.style.setProperty("--safe-bottom-position-guest", "0px");
    });

    return { handleLoginClick };
  },
});
